/**
 * U.S. public marketing frontend (aurorageriatric.com).
 * Keep in sync with root routing in App.js (LandingUS vs LATAM Landing).
 */
export function isUsMarketingHost() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "aurorageriatric.com" || h === "www.aurorageriatric.com";
}
